exports = module.exports = require("../../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pc-pill-button{height:30px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;border-radius:6px;-webkit-box-align:center;-webkit-align-items:center;align-items:center;text-align:center;font-size:12px;font-weight:700;overflow:hidden}.pc-pill-button__left{background-color:#f2f2f2;padding:0 2px;box-sizing:border-box;min-width:70px;color:#4c4c4c}.pc-pill-button__left,.pc-pill-button__right{height:100%;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.pc-pill-button__right{background-color:#ffe363;min-width:40px;color:#303133}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/component/post-gift/component/pill-button/index.vue
// module id = 786
// module chunks = 0 1